var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"empty-feed-state flex items-center flex-col pt-12 pb-20 mx-auto bg-white rounded-xl text-medium"},[_c('div',{staticClass:"icon bg-brand-lightest rounded-full mb-6 w-24 h-24"}),_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }